import React from 'react';
import { Box } from '@mui/material';
import shadowVideo from '../../assets/Shadow.mp4';
import goldIcon from '../../assets/GoldIcon.svg';
import loadingText from '../../assets/LoadingScreenText.svg';
import { loadingScreenStyles } from './LoadingScreen.styles';

const LoadingScreen = ({ isFadingOut = false }) => {
  const styles = loadingScreenStyles(isFadingOut);

  return (
    <Box sx={styles.container}>
      {/* Background Video */}
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        sx={styles.video}
      >
        <source src={shadowVideo} type="video/mp4" />
      </Box>
      
      {/* Background Overlay - Merges primary color with video */}
      <Box sx={styles.bgOverlay} />
      
      {/* Content Container */}
      <Box sx={styles.contentContainer}>
        {/* Gold Icon */}
        <Box
          component="img"
          src={goldIcon}
          alt="Gold Icon"
          sx={styles.goldIcon}
        />
        
        {/* Loading Text */}
        <Box
          component="img"
          src={loadingText}
          alt="Loading"
          sx={styles.loadingText}
        />
      </Box>
    </Box>
  );
};

export default LoadingScreen;

